import {MultiSelect} from '@progress/kendo-react-dropdowns';
import './FrightOrder.css';
import * as tmsCall from '../common/restService/tmServices';
import React, { Component,useRef, useState } from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import '@progress/kendo-theme-default/dist/all.css';
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import constants from "../common/restService/constant";
import * as HanaServices from "../common/restService/hanaService";
import * as TmsService from "../common/restService/tmServices";
import GatewayGet from "../common/restService/GatewayGet";
import { Window } from '@progress/kendo-react-dialogs';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import location from "../location.json";
import $, { event } from 'jquery';  
import { ToastContainer, toast } from 'react-toastify';
import kendo from '@progress/kendo-ui';
import 'react-toastify/dist/ReactToastify.css';

import { filterBy } from '@progress/kendo-data-query';
import { orderBy } from '@progress/kendo-data-query';

import {DatePicker} from '@progress/kendo-react-dateinputs';
import {process} from '@progress/kendo-data-query';
import Loaders from '../Loaders';
import BlockUi from '@availity/block-ui';
import { withRouter } from "../NCRMSHome/withRouter";



const dataState = {

   sort: [{ 
   field: "FO_NUMBER", dir: "desc" },
   { field: "DOC_TYPE", dir: "asc" },
   { field: "CARRIER_SCAC", dir: "asc" },
   { field: "HAWB_NUMBER", dir: "asc" },
   { field: "PRO_NUMBER", dir: "asc" },
   { field: "DOC_STATUS", dir: "asc" },
   { field: "CTSI_FILENAME", dir: "asc" },
   { field: "SOURCE_LOCDESC", dir: "asc" },
   { field: "DESTINATION_LOCDESC", dir: "asc" },
   { field: "CHILD_SCAC", dir: "asc" },
   { field: "CARRIER_ID", dir: "asc" },
   { field: "RFQ_NUMBER", dir: "asc" },
   { field: "QUOTE_NUMBER", dir: "asc" },
   { field: "CREATION_DATE", dir: "asc" },
   { field: "CREATED_BY", dir: "asc" }],
   take: 10,
   skip: 0
};


class FrightOrderSearch extends React.Component{

constructor(props){
super(props);
var startDate = new Date();
startDate.setDate(startDate.getDate() - 180);
var endDate = new Date();
endDate.setDate(endDate.getDate() + 1);
this.DefaultLoad={statusDescr:'Select Status'};
this.parentScacItem={text:'Select Parent SCAC'};

this.state={
   req_hide:false,
   rfqnumhide:false,
   roleList:[],
   userid:[],

   CARRIER_ID:[],
   showButton:false,
    clear:'',
    Fonumber:false,
    FromDate:startDate,
    ToDate:endDate,
    blocking:true,
    fileName:[],
    HAWB_CW_hide:false,
    documentData : [],
   selectDocType : [{docType : "ZSSB" , text : "Intel Shipment Request"},
                   {docType : "ZMSB" , text : "Multi-Bid Request"},
                   {docType : "ZEXC" , text : "Invoice Adjustment Request "}],
   BindLoadStatus:[],
   FilterStatus:[],
   BindFoDocument:[],
   dataState:dataState,
   ParentScacVisible_bb:false,
   ParentScacVisible_carrier:false,
   ParentScacVisible_approver:false,
   
   //bindChildScac:[],
   
   //ParentScacValue:[],
   LoadStatusValue:{statusDescr:'Select Status'},
   childSCACvalue:'',
   //Fonumbers:[],
   FFnum:[],
   FONumberReqValue:'',
   HAWBNumValue:'',
   RFQNumberValue:'',
   PRONumberValue:'',
   CTSI_FILENAME:[],
  Invoice_number:[],
  INVOICE_AMOUNT:[],
  AMOUNT_CURRENCY:[],
  HAWB_NUMBER:[],
  CHILD_SCAC:[],
  SHIP_DATE:[],
  BindParentScac:[],
  ParentDropDownlist:{text:'Select Parent SCAC'},
  ParentFilter:[],
  ClearParent:'',
  ParentcarrierScac:[],
  successmsg:"",
  filter:{}       
}

this.baseState = this.state;
this.searchRecord=this.searchRecord.bind(this);
this.resetvalue=this.resetvalue.bind(this);
this.popup = this.popup.bind(this);
//this.resetvalue=this.resetvalue.bind(this);
}
/********onChange****** */

filterbyStatus=(event)=>{

   this.setState({BindLoadStatus:this.modfilterData(event.filter),clear:event.filter.value});

}

  modfilterData(filter) {
       const data = this.state.FilterStatus.slice();
       return filterBy(data, filter);
   }


   ParentFilterChanged=(event)=>{

       this.setState({BindParentScac:this.modifyParent(event.filter),ClearParent:event.filter.value});
   }   

   modifyParent(filter){
       const data=this.state.ParentFilter.slice();
       return filterBy(data,filter);
   }

fromdateChanged=(event)=>{
   this.setState({FromDate:event.value});
}

TodateChanged=(event)=>{
   this.setState({ToDate:event.value});
}
handleDocTypeChange = (event) => {
   
   this.setState({selectDocType: event.target.value});   
}

FONumberReqChanged=(event)=>{
   this.setState({FONumberReqValue:event.target.value});
}
RFQChanged=(event)=>{
   this.setState({RFQNumberValue:event.target.value});
}

loadStatusChanged=(event)=>{
   this.setState({LoadStatusValue:event.target.value});
}

HawbChanged=(event)=>{
   this.setState({HAWBNumValue:event.target.value});
}
PronumChanged=(event)=>{
   this.setState({PRONumberValue:event.target.value});
}

childScacChanged=(event)=>{

   this.setState({childSCACvalue:event.target.value});
}
ParentScacChanged=(event)=>{
   this.setState({ParentDropDownlist:event.target.value});

}


async componentDidMount(){

 
       //delete this.state.selectDocType;
   $("#myModal").hide();   
 
  this.getUserDetail();
  //this.defaultSearch();
  //$("#NcrmSearch").hide();
   this.loadDocType();
   this.LoadStatusFunction();
   let profile = JSON.parse(sessionStorage.getItem('profile'));
   this.state.roleList = profile['ROLE_LIST'];

  if(this.state.roleList["CW"] == "True"){

   this.state.selectDocType=[{docType : "ZSSB" , text : "Intel Shipment Request"}];

    //$(".k-multiselect-wrap ul li.k-button:nth-child(2),.k-multiselect-wrap ul li.k-button:nth-child(3)").hide();
    this.setState({HAWB_CW_hide:true,req_hide:true,rfqnumhide:true});
    
  }else if(this.state.roleList["CARRIER"] == "True"){

   this.setState({rfqnumhide:true});
   this.state.selectDocType=[{docType : "ZSSB" , text : "Intel Shipment Request"},{docType : "ZEXC" , text : "Invoice Adjustment Request "}];

  }

}


async getUserDetail(){


   let props = {};
   let inputObj = {};
   props["query"] = constants.serviceRoot;
   props["headers"] = constants.serviceHeaders;
   inputObj["Activity"] = "GET_USER_DETAILS";
   inputObj["Input"] = "";
   props.input = inputObj;
   
const userprofile = await GatewayGet(props, props.input);
//console.log("xxxxx",userprofile);
const result = userprofile["RESULT"];
//console.log("result",result);
this.state.successmsg = userprofile["MESSAGE"];
this.state.userName = result['FIRST_NAME'] + ' ' + result['LAST_NAME'];
this.state.roleList = result['ROLE_LIST'];
this.state.ParentcarrierScac=result['CARRIER_SCAC'];
this.state.CARRIER_ID=result['CARRIER_ID'];
//console.log("useriduserid",result["USER_ID"]);
this.setState({userid:result["USER_ID"]});
// console.log("this.state.roleList",this.state.roleList["BB"]);
if(this.state.roleList["BB"]=="True"){

   this.setState({ParentScacVisible_bb:false});
   let props = {};
   let inputObj = {};
   props["query"] = constants.serviceRoot;
   props["headers"] = constants.serviceHeaders;
   inputObj["Activity"] = "F4_CARRIERS_SCAC";
   inputObj["Input"] = "";
   props.input = inputObj;    
   const parentScac = await GatewayGet(props, props.input);    
   this.setState({BindParentScac:parentScac,ParentFilter:parentScac});    
 
}else if(this.state.roleList["CARRIER"]=="True"){
   
   
   this.setState({ParentScacVisible_carrier:true});

}else if(this.state.roleList["APPROVER"]=="True"){
   
   this.setState({ParentScacVisible_approver:false});

   let props = {};
   let inputObj = {};
   props["query"] = constants.serviceRoot;
   props["headers"] = constants.serviceHeaders;
   inputObj["Activity"] = "F4_CARRIERS_SCAC";
   inputObj["Input"] = "";
   props.input = inputObj;    
   const parentScac = await GatewayGet(props, props.input);
   this.setState({BindParentScac:parentScac,ParentFilter:parentScac});
}

this.defaultSearch();    
}






async defaultSearch(){
     

  if(this.state.roleList['BB']=="True"){
  this.setState({filter:{
   logic: "and",
   filters: [
       { field: "CREATED_BY", operator: "contains", value:this.state.userName }
     ]
   }       });

}

if(this.state.roleList['CARRIER']=="True" || this.state.roleList['APPROVER']=="True" || this.state.roleList['CW']=="True"){

   this.setState({filter:{
       logic: "and",
       filters: [
            { field: "CREATED_BY", operator: "contains", value:"" }
         ]
       }       });
   

}


   var startDate= this.state.FromDate;
   var endDate=this.state.ToDate;    

       var d = new Date(startDate),
       month = '' + (d.getMonth() + 1),
       day = '' + d.getDate(),
       year = d.getFullYear();
       if (month.length < 2) month = '0' + month;
       if (day.length < 2) day = '0' + day;
       var formattedFreightOrderFromDate = [year, month, day].join('');
   

       var d = new Date(endDate),
       month = '' + (d.getMonth() + 1),
       day = '' + d.getDate(),
       year = d.getFullYear();

   if (month.length < 2) month = '0' + month;
   if (day.length < 2) day = '0' + day;
   var formattedFreightOrderToDate = [year, month, day].join('');

  
   var DocTypeData=this.state.selectDocType;    
   var DocListItem=[];
   for(var i=0;i<DocTypeData.length;i++){
           if(DocTypeData[i].docType){
              DocListItem.push(DocTypeData[i].docType);
             }
       }

 //var objs={'DocTypeValue':DocListItem};

 var inputObjs = {};

 if(this.state.roleList["CARRIER"]=="True"){

   inputObjs["im_doctype"]=["ZSSB","ZEXC"];

 }else if(this.state.roleList["CW"]=="True"){

   inputObjs["im_doctype"]=["ZSSB"];

 }else if(this.state.roleList["BB"]=="True" || this.state.roleList["APPROVER"]=="True"){

   inputObjs["im_doctype"] = DocListItem;

 }
 
 //inputObjs["im_doctype"] = DocListItem;

//   console.log("this.state.LoadStatusValue",this.state.LoadStatusValue);
//    if(this.state.LoadStatusValue == "")
//    inputObjs["im_docstatus"] = "";
//    else
  inputObjs["im_docstatus"] = "";
  inputObjs["im_startdate"] = formattedFreightOrderFromDate;
  inputObjs["im_enddate"] = formattedFreightOrderToDate;
  inputObjs["im_fonumber"] = this.state.FONumberReqValue;
  inputObjs["im_rfqnumber"] = this.state.RFQNumberValue;					
  inputObjs["im_hawbnumber"] = this.state.HAWBNumValue;
  inputObjs["im_pronumber"] = this.state.PRONumberValue;
 // inputObjs["UserIDName"]=this.state.UserId;
  

 console.log('inputObjs',inputObjs);
  
if(this.state.roleList["BB"]=="True"){

   if(this.state.ParentDropDownlist.text=="Select Parent SCAC" || !this.state.ParentDropDownlist.value)
   {
       inputObjs["im_parentscac"] ="";      
   }else{
 inputObjs["im_parentscac"] = this.state.ParentDropDownlist.text;
}
 inputObjs["im_childscac"] = this.state.childSCACvalue;

}else if(this.state.roleList["CARRIER"]=="True"){
   
   inputObjs["im_parentscac"] = this.state.ParentcarrierScac;
   //this.state.CARRIER_ID
   inputObjs["im_childscac"] ="";

}else if(this.state.roleList["APPROVER"]=="True"){

   if(this.state.ParentDropDownlist.text=="Select Parent SCAC"  || !this.state.ParentDropDownlist.value)
   {
       inputObjs["im_parentscac"] ="";      
   }else{
 inputObjs["im_parentscac"] = this.state.ParentDropDownlist.text;
   }
   inputObjs["im_childscac"] = this.state.childSCACvalue;
}
  

let InputJSONString =JSON.stringify(inputObjs);
//console.log("InputJSONString",InputJSONString);
let props = {};
let inputObj = {};
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;
inputObj["Activity"] = "FO_WORKLIST_SEARCH";
inputObj["Input"] = InputJSONString;
props.input = inputObj;
const FODocumentResult = await GatewayGet(props, props.input);
console.log("FODocumentResult",FODocumentResult);
const FODOCResult=FODocumentResult.RESULT;
console.log("FODOCResult",FODOCResult);

if(FODOCResult!=undefined){
  

    this.setState({BindFoDocument:FODOCResult});    

   toast.success(FODocumentResult.MESSAGE, {
       position: "top-right",
       autoClose: 5000,
       hideProgressBar: false,
       closeOnClick: true,
       pauseOnHover: true,
       draggable: true,
       progress: undefined,
       theme:"colored"
       });
       this.setState({blocking: !this.state.blocking,ClearParent:''});

     // this.getUserDetail();
}else{
  
   toast.error(FODocumentResult.MESSAGE, {
       position: "top-right",
       autoClose: 5000,
       hideProgressBar: false,
       closeOnClick: true,
       pauseOnHover: true,
       draggable: true,
       progress: undefined,
       });
       this.setState({blocking: !this.state.blocking,ClearParent:''});

}



}



async LoadStatusFunction(){

   let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;
InputJSONString ="";
   inputObj["Activity"] = "F4_DOCSTATUS_DROPDWN";
   inputObj["Input"] = InputJSONString;
   props.input = inputObj;
   const GetLoadStatus = await GatewayGet(props, props.input);
 //  const GetLoadStatus=await tmsCall.LoadStatusData();
   console.log(GetLoadStatus)
   this.setState({BindLoadStatus:GetLoadStatus,FilterStatus:GetLoadStatus});    
   }

   

async searchRecord(){
   
   this.setState({blocking: !this.state.blocking,ClearParent:''});

   this.setState({filter:[]});

       
   var startDate= this.state.FromDate;
   var endDate=this.state.ToDate;    

       var d = new Date(startDate),
       month = '' + (d.getMonth() + 1),
       day = '' + d.getDate(),
       year = d.getFullYear();
       if (month.length < 2) month = '0' + month;
       if (day.length < 2) day = '0' + day;
       var formattedFreightOrderFromDate = [year, month, day].join('');
       //console.log("formattedFreightOrderFromDate",formattedFreightOrderFromDate);       

       var d = new Date(endDate),
       month = '' + (d.getMonth() + 1),
       day = '' + d.getDate(),
       year = d.getFullYear();

   if (month.length < 2) month = '0' + month;
   if (day.length < 2) day = '0' + day;
   var formattedFreightOrderToDate = [year, month, day].join('');

  
   var DocTypeData=this.state.selectDocType;    
   var DocListItem=[];
   for(var i=0;i<DocTypeData.length;i++){
           if(DocTypeData[i].docType){
              DocListItem.push(DocTypeData[i].docType);
             }
       }

 //var objs={'DocTypeValue':DocListItem};


 var inputObjs = {};				              
 inputObjs["im_doctype"] = DocListItem;
   if(this.state.LoadStatusValue.docStatus == "" || this.state.LoadStatusValue.statusDescr=='Select Status')
   inputObjs["im_docstatus"] = "";
   else
  inputObjs["im_docstatus"] = this.state.LoadStatusValue.docStatus;
  inputObjs["im_startdate"] = formattedFreightOrderFromDate;
  inputObjs["im_enddate"] = formattedFreightOrderToDate;
  inputObjs["im_fonumber"] = this.state.FONumberReqValue;
  inputObjs["im_rfqnumber"] = this.state.RFQNumberValue;					
  inputObjs["im_hawbnumber"] = this.state.HAWBNumValue;
  inputObjs["im_pronumber"] = this.state.PRONumberValue;
  
if(this.state.roleList["BB"]=="True"){

   if(this.state.ParentDropDownlist.text=="Select Parent SCAC"  || !this.state.ParentDropDownlist.value)
   {
       inputObjs["im_parentscac"] ="";      
   }else{
 inputObjs["im_parentscac"] = this.state.ParentDropDownlist.text;
}
 inputObjs["im_childscac"] = this.state.childSCACvalue;

}else if(this.state.roleList["CARRIER"]=="True"){
   
   inputObjs["im_parentscac"] = this.state.ParentcarrierScac;
   inputObjs["im_childscac"] ="";

}else if(this.state.roleList["APPROVER"]=="True"){

   if(this.state.ParentDropDownlist.text=="Select Parent SCAC" || !this.state.ParentDropDownlist.value)
   {
       inputObjs["im_parentscac"] ="";      
   }else{
       inputObjs["im_parentscac"] = this.state.ParentDropDownlist.text;
   }
   inputObjs["im_childscac"] = this.state.childSCACvalue;
}



if(this.state.selectDocType.length != 0){
  
let InputJSONString =JSON.stringify(inputObjs);
console.log("InputJSONString",InputJSONString);
let props = {};
let inputObj = {};
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;
inputObj["Activity"] = "FO_WORKLIST_SEARCH";
inputObj["Input"] = InputJSONString;
props.input = inputObj;
const FODocumentResult = await GatewayGet(props, props.input);
console.log("FODocumentResult",FODocumentResult);
const FODOCResult=FODocumentResult.RESULT;

console.log("FODOCResult",FODOCResult);

if(FODOCResult!=undefined){
    $("#NcrmSearch").show();
   this.setState({BindFoDocument:FODOCResult});    

   toast.success(FODocumentResult.MESSAGE, {
       position: "top-right",
       autoClose: 5000,
       hideProgressBar: false,
       closeOnClick: true,
       pauseOnHover: true,
       draggable: true,
       progress: undefined,
       theme : "colored"
       });

      // this.getUserDetail();
}else{

   $("#NcrmSearch").hide();
   toast.error(FODocumentResult.MESSAGE, {
       position: "top-right",
       autoClose: 5000,
       hideProgressBar: false,
       closeOnClick: true,
       pauseOnHover: true,
       draggable: true,
       progress: undefined,
       });
}
}

else{
   
   
   toast.error("Please choose atleast one document type...");

}

this.setState({loader:false})

this.setState({blocking: false});

}







loadDocType(){
 
   let profile = JSON.parse(sessionStorage.getItem('profile'));
   this.state.roleList = profile['ROLE_LIST'];



if(this.state.roleList["CW"]=='True'){

   var docType = [];
   var docTypeObj = {};
   docTypeObj["docType"] = "ZSSB";
   docTypeObj["text"] = "Intel Shipment Request";
   docType.push(docTypeObj);
   this.setState({documentData:docType});
   //this.setState({documentData:docType,selectDocType:{docType : "ZSSB" , text : "Intel Shipment Request"}});
  // this.forceUpdate();

}else if(this.state.roleList["CARRIER"]=="True") {
  
   var docType = [];
   var docTypeObj = {};
   docTypeObj["docType"] = "ZSSB";
   docTypeObj["text"] = "Intel Shipment Request";
   docType.push(docTypeObj);
   docTypeObj = {};
   docTypeObj["docType"] = "ZEXC";
   docTypeObj["text"] = "Invoice Adjustment Request";
   docType.push(docTypeObj);
   
   this.setState({documentData:docType});
  }
  else{


   var docType = [];
   var docTypeObj = {};
   docTypeObj["docType"] = "ZSSB";
   docTypeObj["text"] = "Intel Shipment Request";
   docType.push(docTypeObj);
   docTypeObj = {};
   docTypeObj["docType"] = "ZMSB";
   docTypeObj["text"] = "Multi-Bid Request";
   docType.push(docTypeObj);
   docTypeObj = {};
   docTypeObj["docType"] = "ZEXC";
   docTypeObj["text"] = "Invoice Adjustment Request";
   docType.push(docTypeObj);
   
   this.setState({documentData:docType});
  }
   
}



closebtn(){ $("#myModal").hide();}

async popup(dataItem,event){

   
  const editData = dataItem.dataItem;
  
  const CtsiFileName=editData.CTSI_FILENAME;
  //const Fonum=editData.FO_NUMBER;
  const InvoiceAmt=editData.INVOICE_AMOUNT;
  const Amtcurrency=editData.AMOUNT_CURRENCY;
  const hawb=editData.HAWB_NUMBER;
  const chscsc=editData.CHILD_SCAC;
  const shipingdate=editData.SHIP_DATE;
  const Invocenumber=editData.PRO_NUMBER;

  var y=shipingdate.substr(0,4);
  var m=shipingdate.substr(4,2);
  var d=shipingdate.substr(6,2);
  var shiping_date = m +"/"+ d +"/"+ y;

  console.log(this.state.Fonumbers);
  this.setState({CTSI_FILENAME:CtsiFileName,
                Invoice_number:Invocenumber,INVOICE_AMOUNT:InvoiceAmt,AMOUNT_CURRENCY:Amtcurrency,
                HAWB_NUMBER:hawb,CHILD_SCAC:chscsc,SHIP_DATE:shiping_date
               });

 $("#myModal").show();

}

async resetvalue(){

   document.querySelector(".searchButtonFinal").disabled=true;
  this.setState({blocking: !this.state.blocking});   
this.setState({clear:'',ClearParent:''});
this.setState(this.baseState);
this.LoadStatusFunction(); 
//this.getUserDetail();
//$("#NcrmSearch").hide();
let props = {};
let inputObj = {};
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;
inputObj["Activity"] = "GET_USER_DETAILS";
inputObj["Input"] = "";
props.input = inputObj;

const userprofile = await GatewayGet(props, props.input);
//console.log("xxxxx",userprofile);
const result = userprofile["RESULT"];
//console.log("result",result);
this.state.successmsg = userprofile["MESSAGE"];
this.state.userName = result['FIRST_NAME'] + ' ' + result['LAST_NAME'];
this.state.roleList = result['ROLE_LIST'];
this.state.ParentcarrierScac=result['CARRIER_SCAC'];
this.state.CARRIER_ID=result['CARRIER_ID'];
//console.log("useriduserid",result["USER_ID"]);
this.setState({userid:result["USER_ID"]});
// console.log("this.state.roleList",this.state.roleList["BB"]);

if(this.state.roleList["BB"]=="True"){

this.setState({ParentScacVisible_bb:false});
let props = {};
let inputObj = {};
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;
inputObj["Activity"] = "F4_CARRIERS_SCAC";
inputObj["Input"] = "";
props.input = inputObj;    
const parentScac = await GatewayGet(props, props.input);    
this.setState({BindParentScac:parentScac,ParentFilter:parentScac});    

}else if(this.state.roleList["CARRIER"]=="True"){


this.setState({ParentScacVisible_carrier:true});

}else if(this.state.roleList["APPROVER"]=="True"){

this.setState({ParentScacVisible_approver:false});

let props = {};
let inputObj = {};
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;
inputObj["Activity"] = "F4_CARRIERS_SCAC";
inputObj["Input"] = "";
props.input = inputObj;    
const parentScac = await GatewayGet(props, props.input);
this.setState({BindParentScac:parentScac,ParentFilter:parentScac});

 }

// this.setState({blocking:false});
document.querySelector(".searchButtonFinal").disabled=false;
}






  //,ClearParent:event.filter.value
dropdownParentChanged=(event)=>{
   this.setState({ParentDropDownlist:event.target.value});
}

// const listItems = this.state.BindFoDocument.map((myList) =>  
// <li>{if(myList.VIEW_DETAILS_INDICATOR)}</li>  

// );  

onButtonClick(e) {
   this.props.navigate('/intelshipment',{ state: {searchScreenData:e}})

 }
render(){
 
const grid = (

   <Grid

           ScrollMode="scrollable"
           style={{ height: "600px"}}
           pageable
           sortable
           
         

           data={process(filterBy(this.state.BindFoDocument, this.state.filter),this.state.dataState)}
           
           {...this.state.dataState}
           
           onDataStateChange={(e) => {
               this.setState({ dataState: e.dataState})
           }}
           filterable
           filter={this.state.filter}
           onFilterChange={(e) => {
               this.setState({
                   filter: e.filter
               });
           }}

           dataGrid="myGrid"
           dataBound={this.onDataBound}
           reorderable
           ref={(grid) => { this._grid = grid; }}
           >

<GridColumn locked={true} field="FO_NUMBER" title="Request ID Number" width="150px"  filter="text"  
cell= {props => (<td className="k-grid-content-sticky" role="gridcell" aria-colindex="1"  style={{left: "0px", right: "0px",cursor:"pointer",color:"#6495ed"}} onClick={() => this.onButtonClick(props.dataItem)}>
                  
                  { props.dataItem.FO_NUMBER}
   </td> )}/>
<GridColumn locked={true} field="DOC_TYPE" title="Document Type" filter="text" width="150px"/>
<GridColumn field="CARRIER_SCAC" title="SCAC" filter="text" width="150px"/>
{!this.state.HAWB_CW_hide && <GridColumn field="HAWB_NUMBER" title="HAWB Number" filter="text" width="150px"/>}
<GridColumn field="CREATED_BY" title="Request Created By" filter="text"  width="150px"/>
{!this.state.HAWB_CW_hide && <GridColumn field="PRO_NUMBER" title="PRO Number" filter="text" width="150px"/>}
<GridColumn field="DOC_STATUS" title="Document Status" filter="text" width="150px"/>
{!this.state.HAWB_CW_hide && <GridColumn field="CTSI_FILENAME" title="CTSI Data File Details" filter="text" width="150px"
cell = {props=>(<td>{props.dataItem.VIEW_DETAILS_INDICATOR=='X' && <button className="btn k-button k-button-icontext" id="viewDetails" onClick={this.popup.bind(this,props)}>View Details</button>}</td>)}></GridColumn>}
<GridColumn field="TOBE_AUTHORIZEDBY" title="To be Authorized by" filter="text" width="150px"/>
<GridColumn field="SOURCE_LOCDESC" title="Source Location" filter="text" width="200px"/>
<GridColumn field="DESTINATION_LOCDESC" title="Destination Location" filter="text" width="200px"/>
{!this.state.HAWB_CW_hide && <GridColumn field="CHILD_SCAC" title="Child SCAC" filter="text" width="150px"/>}
{!this.state.HAWB_CW_hide && <GridColumn field="CARRIER_ID" title="Carrier" filter="text" width="150px"/>}
{!this.state.HAWB_CW_hide && <GridColumn field="RFQ_NUMBER" title="RFQ Number" filter="text" width="150px"/>}
{!this.state.HAWB_CW_hide && <GridColumn field="QUOTE_NUMBER" title="Quotation Number" filter="text" width="150px"/>}
<GridColumn field="CREATION_DATE" title="Request Created Date" filter="text" width="150px"/>


</Grid>
);
     
return(
<div>

<BlockUi tag="div" blocking={this.state.blocking}
        
        loader={<Loaders />}>

   <MDBContainer fluid>
   <MDBRow>
       <MDBCol sm="12"className="titleBox"><label>NCRM Request Search</label></MDBCol>
   </MDBRow>

   </MDBContainer>
   <div className="contentborder">
<MDBContainer fluid >
<MDBRow className="rowBtm">
   <MDBCol md='2'><label>Document Type</label></MDBCol>
   <MDBCol md='3'>
   <MultiSelect data = {this.state.documentData} value={this.state.selectDocType} 
   dataItemKey = "docType" textField = "text" onChange = {this.handleDocTypeChange}></MultiSelect>
   </MDBCol>
   <MDBCol md='1'></MDBCol>
   <MDBCol md='2'><label>Status</label></MDBCol>
   <MDBCol md='3'>
   <DropDownList style={{width:'100%'}}
   data={this.state.BindLoadStatus} defaultItem={this.DefaultLoad} onFilterChange={this.filterbyStatus} 
   value={this.state.LoadStatusValue} filter={this.state.clear} onChange={this.loadStatusChanged} dataItemKey="docStatus" filterable={true}
   textField="statusDescr"> </DropDownList>
   </MDBCol>    
</MDBRow>


<MDBRow className="rowBtm">
{!this.state.req_hide &&  <MDBCol md='2'><label>Request ID Number:</label></MDBCol>}
{!this.state.req_hide && <MDBCol md='3'>
   <input type="number" value={this.state.FONumberReqValue} 
   pattern="/^[0-9]*$/" placeholder="Request ID Number" className="form-control" onChange={this.FONumberReqChanged}></input>
   </MDBCol>}
   <MDBCol md='1'></MDBCol>
   {!this.state.rfqnumhide && <MDBCol md='2'><label>RFQ Number:</label></MDBCol>}
   {!this.state.rfqnumhide && <MDBCol md='3'>
   <input type="number" value={this.state.RFQNumberValue} placeholder="RFQ Number" onChange={this.RFQChanged}
    pattern="/^[0-9]*$/" className="form-control"></input>
   </MDBCol>}
</MDBRow>

{!this.state.req_hide && <MDBRow className="rowBtm">
   <MDBCol md='2'><label>HAWB Number#</label></MDBCol>
   <MDBCol md='3'>
   <input type="text" className="form-control" placeholder="Hawb Number"  onChange={this.HawbChanged}
   value={this.state.HAWBNumValue}></input>
   </MDBCol>
   <MDBCol md='1'></MDBCol>
   <MDBCol md='2'><label>PRO Number#</label></MDBCol>
   <MDBCol md='3'>
   <input type="text" className="form-control" placeholder="Pro Number" onChange={this.PronumChanged} value={this.state.PRONumberValue}></input>
   </MDBCol>    
</MDBRow>}

{/* {this.state.ParentScacVisible_approver &&  {this.state.ParentScacVisible_carrier &&  */}
{/* {this.state.ParentScacVisible_carrier &&  */}
{/* <input type="text" className="form-control" onChange={this.ParentScacChanged} value={this.state.ParentScacValue}></input>} */}

{!this.state.ParentScacVisible_approver || !this.state.req_hide && <MDBRow className="rowBtm">
   <MDBCol md='2'><label>Parent SCAC</label></MDBCol>
   <MDBCol md='3'>
  <DropDownList style={{width:'100%'}}    
   data={this.state.BindParentScac} onFilterChange={this.ParentFilterChanged}  onChange={this.dropdownParentChanged} 
   filter={this.ClearParent} defaultItem={this.parentScacItem} 
   value={this.state.ParentDropDownlist} dataItemKey="value" textField="text" filterable={true}>
   </DropDownList> 
   </MDBCol>
   <MDBCol md='1'></MDBCol>    
   <MDBCol md='2'><label>Child SCAC</label></MDBCol>
   <MDBCol md='3'>    
   <input type="text" className="form-control" placeholder="Child SCAC" onChange={this.childScacChanged} value={this.state.childSCACvalue}></input>
   </MDBCol>
   </MDBRow>}
   
{!this.state.ParentScacVisible_bb || !this.state.req_hide && <MDBRow className="rowBtm">
   <MDBCol md='2'><label>Parent SCAC</label></MDBCol>
   <MDBCol md='3'>
  <DropDownList style={{width:'100%'}}    
   data={this.state.BindParentScac} onFilterChange={this.ParentFilterChanged}  onChange={this.dropdownParentChanged} filter={this.ClearParent} defaultItem={this.parentScacItem} value={this.state.ParentDropDownlist} dataItemKey="value" textField="text" filterable={true}>
   </DropDownList> 
   </MDBCol>
   <MDBCol md='1'></MDBCol>    
   <MDBCol md='2'><label>Child SCAC</label></MDBCol>
   <MDBCol md='3'>    
   <input type="text" className="form-control" placeholder="Child SCAC" onChange={this.childScacChanged} value={this.state.childSCACvalue}></input>
   </MDBCol>
   </MDBRow>}


   {!this.state.ParentScacVisible_carrier && <MDBRow className="rowBtm">
   <MDBCol md='2'><label>Parent SCAC</label></MDBCol>
   <MDBCol md='3'>
  <DropDownList style={{width:'100%'}}    
   data={this.state.BindParentScac} onFilterChange={this.ParentFilterChanged}  onChange={this.dropdownParentChanged} filter={this.ClearParent} defaultItem={this.parentScacItem} value={this.state.ParentDropDownlist} dataItemKey="value" textField="text" filterable={true}>
   </DropDownList> 
   </MDBCol>
   <MDBCol md='1'></MDBCol>    
   <MDBCol md='2'><label>Child SCAC</label></MDBCol>
   <MDBCol md='3'>    
   <input type="text" className="form-control" placeholder="Child SCAC" onChange={this.childScacChanged} value={this.state.childSCACvalue}></input>
   </MDBCol>
   </MDBRow>}


{/* 
   {this.state.ParentScacVisible_approver && <MDBRow className="rowBtm">
   <MDBCol md='2'>Parent SCAC</MDBCol>
   <MDBCol md='3'>
  <DropDownList style={{width:'100%'}}    
   data={this.state.BindParentScac} onFilterChange={this.ParentFilterChanged}  onChange={this.dropdownParentChanged} filter={this.ClearParent} defaultItem={this.parentScacItem} value={this.state.ParentDropDownlist} dataItemKey="value" textField="text" filterable={true}>
   </DropDownList> 
   </MDBCol>
   <MDBCol md='1'></MDBCol>    
   <MDBCol md='2'>Child SCAC</MDBCol>
   <MDBCol md='3'>    
   <input type="text" className="form-control" placeholder="Child SCAC" onChange={this.childScacChanged} value={this.state.childSCACvalue}></input>
   </MDBCol>
   </MDBRow>}
*/}


   <MDBRow className="rowBtm">
   <MDBCol md='2'><label>Request Created Date From</label> </MDBCol>
   <MDBCol md='3'> 
   <DatePicker format="MM/dd/yyyy" formatPlaceholder="formatPattern" value={this.state.FromDate} defaultItem={this.frmDate} onChange={this.fromdateChanged}></DatePicker>
   </MDBCol>
   <MDBCol md='1'></MDBCol>
   <MDBCol md='2'><label>To</label></MDBCol>
   <MDBCol md='3'>
   <DatePicker format="MM/dd/yyyy" formatPlaceholder="formatPattern" value={this.state.ToDate} defaultItem={this.frmDate} onChange={this.TodateChanged}></DatePicker>
   </MDBCol>
   </MDBRow>

   <MDBRow className="rowBtm">

       <MDBCol md="12">
               <p className="btnalign">
          
           <button type="submit" className="btn k-button k-button-icontext mt searchButtonFinal" id="comBtn" onClick={this.searchRecord}>Search</button>
           <button type="submit" className="btn k-button k-button-icontext btn-default reset"  id="comBtn" onClick={this.resetvalue}>Reset</button></p>
          
           </MDBCol>
       
   </MDBRow>

</MDBContainer>
</div>
<MDBContainer fluid className="box-containers" id="NcrmSearch" style={{paddingLeft: "40px"}}>
   <MDBRow>
       <MDBCol md='12'>
           
               <div>

               {grid}

               </div>

       </MDBCol>
   </MDBRow>
</MDBContainer>



<div className="container">

 <div className="modal" id="myModal">
   
   <div className="modal-content">
     <div className="modal-header">
     <p className="tti">CTSI Data File Details</p>
     <p className="cls"><button type="button" className="close" onClick={this.closebtn}>&times;</button></p>
     </div>
     <div className="modal-body">
         
     <table className="table table-bordered popups"><tr><td>File Name</td><td>{this.state.CTSI_FILENAME}</td></tr>
       <tr><td>Invoice Number</td><td>{this.state.Invoice_number}</td></tr>
       <tr><td>Invoice Amount </td><td>{this.state.INVOICE_AMOUNT}</td></tr>
       <tr><td>Amount Currency</td><td>{this.state.AMOUNT_CURRENCY}</td></tr>
       <tr><td>HAWB</td><td>{this.state.HAWB_NUMBER}</td></tr>
       <tr><td>Child SCAC</td><td>{this.state.CHILD_SCAC}</td></tr>
       <tr><td>Ship Date</td><td>{this.state.SHIP_DATE}</td></tr>
     </table>
     </div>
     <div className="modal-footer">
     <button type="button" className="btn btn-default" onClick={this.closebtn}>Close</button>
     </div>
     
   </div>
 </div>
 
 </div>
 </BlockUi>
</div>
)


 }
}
export default withRouter(FrightOrderSearch);


// console.log(data);
// var scacCodes = [];
// for (var i = 0; i < data.length; i++) {
//     if (data[i].CHILD_SCAC) {
//         var obj = {};
//         obj.text = data[i].CHILD_SCAC + " - " + data[i].CHILD_SCAC;
//         obj.value = data[i].CHILD_SCAC;
//         scacCodes.push(obj);
//     }

// }
// console.log("scacCodes",scacCodes);
// this.setState({bindChildScac:scacCodes});
// return scacCodes;




